import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';
import P from '@hero/ui-kit/typography/P';
import { getTabSearchParams } from '../utils/tabParams';
import * as Style from './style.module.scss';

const MemberTabs: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const setQueryFilterType = (type: string) => {
        setSearchParams((prev) => getTabSearchParams(prev, type));
    };

    const tabs = React.useMemo(() => {
        const filterType = searchParams.get('list_version');

        return [
            {
                value: 'active',
                label: 'Active',
                isActive: filterType === 'active' || !filterType
            },
            {
                value: 'discharged_and_cancelled',
                label: 'Discharged',
                isActive: filterType === 'discharged_and_cancelled'
            },
            {
                value: 'disengaged',
                label: 'Disengaged',
                isActive: filterType === 'disengaged'
            },
            {
                value: 'checkin-members',
                label: 'Monthly Check-ins',
                isActive: filterType === 'checkin-members'
            }
        ];
    }, [searchParams]);

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '2.8rem',
                minHeight: '4rem'
            }}
        >
            {tabs.map((tab) => (
                <ClickableOpacity
                    key={tab.value}
                    alt={`Set ${tab.value} filter`}
                    onClick={() => setQueryFilterType(tab.value)}
                >
                    <P
                        noDefaultMargin
                        strong
                        className={`${Style.btn} ${tab.isActive ? Style.active : ''}`}
                    >
                        {tab.label}
                    </P>
                </ClickableOpacity>
            ))}
        </div>
    );
};

export default MemberTabs;
